import styled, { css } from 'styled-components';

export const RadioWrapper = styled.span``;

export const RadioInput = styled.input<{ error?: string | boolean }>`
  /* take it out of document flow */
  position: absolute;
  /*  hide it */
  opacity: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;

  & + label {
    position: relative;
    display: inline-block;
    vertical-align: top;
    padding-right: 30px;
    cursor: pointer;
    line-height: 20px;
  }

  & + label:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    transition: all 0.5s ease;
    background: white;
    border: 1px solid ${({ theme, error }) => (error ? theme.defaultColors.error : 'grey')};
  }

  &:checked + label:after {
    display: block;
    position: absolute;
    content: '';
    top: 6px;
    right: 6px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    ${({ theme }) => css`
      border: 1px solid ${theme.defaultColors.fontSecondary};
      background-color: ${theme.defaultColors.fontSecondary};
    `};

    ${({ theme }) => css`
      background: ${theme.defaultColors.fontSecondary};
    `};
  }

  &:disabled + label {
    color: ${({ theme }) => theme.defaultColors.fontSecondary};
    cursor: default;
  }

  &:disabled + label:before {
    border: 1px solid ${({ theme, error }) => (error ? theme.defaultColors.error : 'grey')};
    background: white;
  }
`;
